import { LDFlagSet } from "launchdarkly-js-sdk-common";

export const isOutsideOpenEnrollment = ({
  mctYpPublicPreview,
  mctYpOpenEnrollment,
  mctYpOeNextYear,
  mctYpOutsideOpenEnrollment,
}:
  | {
      mctYpPublicPreview: boolean;
      mctYpOpenEnrollment: boolean;
      mctYpOeNextYear: boolean;
      mctYpOutsideOpenEnrollment: boolean;
    }
  | LDFlagSet): boolean => {
  return (
    mctYpOutsideOpenEnrollment ||
    (!mctYpOeNextYear && !mctYpPublicPreview && !mctYpOpenEnrollment)
  );
};
